import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";

// Images
import bgImage from "assets/images/icons/catering-icons/food_3.svg";

import EmailVerification from "../components/EmailVerification";
import {
  createLinkedAccountApi,
  verifyLinkedAccountApi,
  updateCustomerInfoForCampaign,
} from "../_request";

// react-router-dom components
import { useNavigate } from "react-router-dom";
import { useAuth } from "context";
import { unLinkedCustomerAccount } from "layouts/profile/_request";
import { getCustomerAPI } from "../../profile/_request";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import SideBanner from "../../../examples/LayoutContainers/SideBanner";
import Divider from "@mui/material/Divider";

const VerifyWorkEmails = () => {
  const { showSnackbarWithMessage } = useAuth();
  const navigate = useNavigate();
  const [emails, setEmails] = useState([]);
  const [campaignCode, setCampaignCode] = useState(null);
  const [campaignExist, setcampaignExist] = useState(null);

  useEffect(() => {
    const getCustomerDetails = async () => {
      const {
        data: { success, data },
      } = await getCustomerAPI();
      if (success) {
        let linkedAccounts;
        if (data.customer?.customer_linked_accounts?.length > 0) {
          linkedAccounts = data.customer.customer_linked_accounts.map((account) => ({
            email: account.email,
            isOTPVisible: account.verifiedAt !== null,
            otpNumber: "",
            isVerified: account.verifiedAt !== null,
            linkedAccountId: account.id,
          }));
          setEmails(linkedAccounts);
        } else {
          linkedAccounts = {
            email: "",
            isOTPVisible: false,
            otpNumber: "",
            disabled: false,
            isVerified: false,
            linkedAccountId: "",
          };
          if (data.customer?.customer_restaurant_stores_infos?.length > 0) {
            setcampaignExist(data.customer?.customer_restaurant_stores_infos[0]._campaign);
          }
          setEmails([linkedAccounts]);
        }
      }
    };
    getCustomerDetails();
  }, []);

  const handleFieldChange = (event, index) => {
    const { name, value } = event.target;
    const updatedEmails = [...emails];
    updatedEmails[index][name] = value;
    setEmails(updatedEmails);
  };

  const handleSendOTP = async (index) => {
    try {
      const {
        data: { success, message, data },
      } = await createLinkedAccountApi({ email: emails[index].email });
      if (success) {
        const updatedEmails = [...emails];
        updatedEmails[index].isOTPVisible = true;
        updatedEmails[index].linkedAccountId = data.linkedAccount.id;
        setEmails(updatedEmails);
        showSnackbarWithMessage({
          type: "success",
          message,
        });
      } else {
        showSnackbarWithMessage({
          type: "error",
          message,
        });
      }
    } catch (e) {
      console.log(e.message);
      showSnackbarWithMessage({
        type: "error",
        message: e.message,
      });
    }
  };

  const handleVerify = async (index) => {
    try {
      const {
        data: { success, message, data },
      } = await verifyLinkedAccountApi(
        { code: +emails[index].otpNumber },
        emails[index].linkedAccountId
      );
      if (success) {
        const updatedEmails = [...emails];
        updatedEmails[index].isVerified = true;
        setEmails(updatedEmails);
        showSnackbarWithMessage({
          type: "success",
          message,
        });
      } else {
        showSnackbarWithMessage({
          type: "error",
          message,
        });
      }
    } catch (e) {
      console.log(e.message);
      showSnackbarWithMessage({
        type: "error",
        message: e.message,
      });
    }
  };

  const handleUnlinkedAccount = async (index) => {
    try {
      const {
        data: { success, message },
      } = await unLinkedCustomerAccount(emails[index].linkedAccountId);
      if (success) {
        const updatedEmails = [...emails];
        updatedEmails.splice(index, 1);
        setEmails(updatedEmails);
        showSnackbarWithMessage({
          type: "success",
          message,
        });
      } else {
        showSnackbarWithMessage({
          type: "error",
          message,
        });
      }
    } catch (e) {
      console.log(e.message);
      showSnackbarWithMessage({
        type: "error",
        message: e.message,
      });
    }
  };

  const createInfoData = async () => {
    try {
      const {
        data: { success, message },
      } = await updateCustomerInfoForCampaign(campaignCode);
      if (success) {
        showSnackbarWithMessage({
          type: "success",
          message,
        });
        navigate("/dashboard");
      } else {
        showSnackbarWithMessage({
          type: "error",
          message,
        });
      }
    } catch (e) {
      showSnackbarWithMessage({
        type: "error",
        message: e.message,
      });
    }
  };

  return (
    <MDBox
      display={{
        xs: "flex",
        xl: "row",
        background: "linear-gradient(to right, rgba(1,233,98,0.1), rgba(0,123,255,0.1))",
      }}
      flexDirection={{
        xs: "column-reverse",
        xl: "row",
      }}
    >
      <SideBanner />
      <BasicLayout image={bgImage}>
        <Card sx={{ margin: 2, marginLeft: 3, maxWidth: "648px" }}>
          <MDBox mt={2} p={2} minWidth={{ xs: "320px", xl: "380px" }}>
            <MDTypography variant="h4" fontWeight="regular">
              Link your work emails
            </MDTypography>
          </MDBox>
          <MDBox pt={1} px={2}>
            <MDBox pb={3}>
              <MDTypography variant="h6" fontWeight="light" color="dark" mt={1}>
                Add all of your work emails which you will be using to place orders on the platform.
                These emails will be used to map your orders to your account.
              </MDTypography>
              <MDTypography variant="h6" fontWeight="medium" color="dark" mt={1}>
                Email ID
              </MDTypography>
            </MDBox>

            {emails.map((emailData, index) => (
              <>
                <EmailVerification
                  key={index}
                  emailData={emailData}
                  index={index}
                  onSendOTP={handleSendOTP}
                  onFieldChange={handleFieldChange}
                  onVerify={handleVerify}
                  onUnlinked={handleUnlinkedAccount}
                />
                <Divider />
              </>
            ))}

            <MDInput
              type="text"
              label={!campaignExist && "Campaign Code"}
              name="campaignCode"
              variant="outlined"
              disabled={campaignExist}
              value={campaignExist ? campaignExist : campaignCode}
              onChange={(e) => setCampaignCode(e.target.value)}
            />

            <MDBox mt={4} mb={2} sx={{ display: "flex", justifyContent: "flex-end" }}>
              <MDButton
                variant="text"
                color="info"
                onClick={() => {
                  if (emails.length < 2) {
                    setEmails([
                      ...emails,
                      { email: "", isOTPVisible: false, otpNumber: "", isVerified: false },
                    ]);
                  }
                }}
                disabled={!(emails.length < 2)}
              >
                Add Email
              </MDButton>
              <MDButton
                variant="gradient"
                color="success"
                onClick={() => {
                  if (!campaignExist && campaignCode) {
                    createInfoData();
                  } else {
                    navigate("/dashboard");
                  }
                }}
              >
                Next
              </MDButton>
            </MDBox>
          </MDBox>
        </Card>
      </BasicLayout>
    </MDBox>
  );
};

export default VerifyWorkEmails;
